import { render, staticRenderFns } from "./AuthorContentSection.vue?vue&type=template&id=06ff6b7a&scoped=true"
import script from "./AuthorContentSection.vue?vue&type=script&lang=js"
export * from "./AuthorContentSection.vue?vue&type=script&lang=js"
import style0 from "./AuthorContentSection.vue?vue&type=style&index=0&id=06ff6b7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ff6b7a",
  null
  
)

export default component.exports